import gsap from 'gsap/gsap-core';
// import { Loader, Point, Sprite } from 'pixi.js';

export const hitTest = (sprite1, sprite2, offset = 0) => {
  const rect1 = sprite1.getBounds();
  const rect2 = sprite2.getBounds();

  const isIntersectingX = (rect1.right - offset) > (rect2.left + offset)
                          && (rect1.left + offset) < (rect2.right - offset);
  const isIntersectingY = (rect1.bottom - offset) > (rect2.top + offset)
                          && (rect1.top + offset) < (rect2.bottom - offset);
  return isIntersectingX && isIntersectingY;
};

export const hitTestCenter = (sprite1, sprite2) => {
  const rect1 = sprite2.getBounds();
  const center = { x: rect1.left + rect1.width / 2, y: rect1.top + rect1.height / 2 };
  const rect2 = sprite1.getBounds();
  const isIntersectingX = center.x > rect2.left && center.x < rect2.right;
  const isIntersectingY = center.y > rect2.top && center.y < rect2.bottom;
  return isIntersectingX && isIntersectingY;
};

export const shakeSprite = (sprite) => {
  const amount = 10;
  const tl = gsap.timeline();
  tl.to(sprite.position, { x: `+=${amount}`, duration: 0.05, ease: 'linear.none' });
  tl.to(sprite.position, { x: `-=${amount}`, duration: 0.05, ease: 'linear.none' });
  tl.to(sprite.position, { x: `+=${amount}`, duration: 0.05, ease: 'linear.none' });
  tl.to(sprite.position, { x: `-=${amount}`, duration: 0.05, ease: 'linear.none' });
  tl.to(sprite.position, { x: 0, duration: 0.05, ease: 'linear.none' });
};
